import React, { useState } from "react";
import MDBox from "components/MDBox";

// Custom Components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import PageTitle from "examples/NewDesign/PageTitle";
import BillForm from "examples/modal/BillForm";
import AddButton from "examples/NewDesign/CustomButton/AddButton";
import BillPaymentsListing from "layouts/billPayments/BillsPaymentListing";

// Constant
import { PageTitles, Icons, Colors } from "utils/Constants";
import pxToRem from "assets/theme/functions/pxToRem";

function ProfileForm() {
  const [open, seOpen] = useState(false);
  const [billTitle, setBillTitle] = useState("");

  const handleBillForm = (type) => {
    setBillTitle(type);
    seOpen(true);
  };
  return (
    <DashboardLayout>
      {open && (
        <BillForm
          open={open}
          handleClose={() => seOpen(false)}
          title={billTitle}
          actionButton="Fetch"
        />
      )}
      <MDBox display="flex" justifyContent="space-between">
        <PageTitle title={PageTitles.UTILITY_BILL_PAYMENTS} />
        <MDBox display="flex" flexWrap="wrap" gap={2} flexDirection="row">
          <AddButton
            title={PageTitles.ELECTRICITY}
            icon={Icons.ADD}
            suffixIcon={Icons.ELECTRICITY}
            background={Colors.WHITE}
            color={Colors.BLACK}
            action={() => handleBillForm(PageTitles.ELECTRICITY)}
            ml={pxToRem(0)}
          />
          <AddButton
            title={PageTitles.WATER}
            icon={Icons.ADD}
            suffixIcon={Icons.CODE}
            background={Colors.WHITE}
            color={Colors.BLACK}
            action={() => handleBillForm(PageTitles.WATER)}
            ml={pxToRem(0)}
          />
          <AddButton
            title={PageTitles.GAS}
            icon={Icons.ADD}
            suffixIcon={Icons.CODE}
            background={Colors.WHITE}
            color={Colors.BLACK}
            action={() => handleBillForm(PageTitles.GAS)}
            ml={pxToRem(0)}
          />
          <AddButton
            title={PageTitles.FASTAG}
            icon={Icons.ADD}
            suffixIcon={Icons.CODE}
            background={Colors.WHITE}
            color={Colors.BLACK}
            action={() => handleBillForm(PageTitles.FASTAG)}
            ml={pxToRem(0)}
          />
          <AddButton
            title={PageTitles.MUNCIPAILITY}
            icon={Icons.ADD}
            suffixIcon={Icons.CODE}
            background={Colors.WHITE}
            color={Colors.BLACK}
            action={() => handleBillForm(PageTitles.MUNCIPAILITY)}
            ml={pxToRem(0)}
          />
        </MDBox>
      </MDBox>
      <BillPaymentsListing />
    </DashboardLayout>
  );
}

export default ProfileForm;
